export function usersJson (language) {
  let items

  if (language === 'es') {
    items = {
      newGroupUser: {
        name: 'newGroupUser',
        label: 'crear un grupo'
      },
      newUserUser: {
        name: 'newUserUser',
        label: 'crear un usuario'
      },
      removeUsersUser: {
        name: 'removeUsersUser',
        label: 'eliminar usuarios'
      },
      editUsersUser: {
        name: 'editUsersUser',
        label: 'editar usuarios'
      },
      selectRowsDataTableUser: {
        name: 'selectRowsDataTableUser',
        label: 'seleccionar filas de la tabla de datos'
      }
    }
  } else if (language === 'en') {
    items = {
      newGroupUser: {
        name: 'newGroupUser',
        label: 'create a group'
      },
      newUserUser: {
        name: 'newUserUser',
        label: 'create a user'
      },
      removeUsersUser: {
        name: 'removeUsersUser',
        label: 'delete users'
      },
      editUsersUser: {
        name: 'editUsersUser',
        label: 'edit users'
      },
      selectRowsDataTableUser: {
        name: 'selectRowsDataTableUser',
        label: 'select rows from the data table'
      }
    }
  }

  return (items)
}
